import { Mail, Phone, MapPin, Clock, Instagram, Linkedin, Twitter, MessageCircle } from "lucide-react";
import Reveal from "@/components/common/Reveal";

export default function Contact() {
  return (
    <section id="contact" className="section relative" data-testid="contact-section">
      <div className="container-x relative">
        <div className="grid lg:grid-cols-12 gap-10">
          <Reveal direction="up" className="lg:col-span-5">
            <div>
              <span className="eyebrow">
                <span className="dot" /> Contact
              </span>
              <h2 className="h-display mt-5 text-4xl sm:text-5xl text-[var(--body-fg)]">
                We're an <span className="font-serif italic">email away</span>.
              </h2>
              <p className="mt-5 text-[var(--body-fg)]/65 leading-relaxed">
                Prefer to chat first? Reach out through any of the channels below —
                we usually reply within a couple of hours.
              </p>

              <div className="mt-8 space-y-3">
                <ContactRow
                  icon={Mail}
                  label="Email"
                  value="Muditprataps20138@gmail.com"
                  href="mailto:Muditprataps20138@gmail.com"
                  testId="contact-email"
                />
                <ContactRow
                  icon={Phone}
                  label="Phone"
                  value="+91 9792684098"
                  href="tel:+919792684098"
                  testId="contact-phone"
                />
                <ContactRow
                  icon={MessageCircle}
                  label="WhatsApp"
                  value="Chat instantly"
                  href="https://wa.me/919792684098"
                  testId="contact-whatsapp"
                />
                <ContactRow
                  icon={Clock}
                  label="Business Hours"
                  value="Mon – Sat · 10:00 – 19:00 IST"
                  testId="contact-hours"
                />
                <ContactRow
                  icon={MapPin}
                  label="Based in"
                  value="India · Serving SMBs globally"
                  testId="contact-location"
                />
              </div>

              <div className="mt-8 flex items-center gap-2">
                {[
                  { icon: Linkedin, href: "#" },
                  { icon: Twitter, href: "#" },
                  { icon: Instagram, href: "#" },
                ].map(({ icon: I, href }, i) => (
                  <a
                    key={i}
                    href={href}
                    className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-[var(--glass-border)] text-[var(--body-fg)]/70 hover:text-[var(--brand)] hover:border-[var(--card-hover-border)] transition"
                    data-testid={`social-link-${i}`}
                  >
                    <I className="w-4 h-4" />
                  </a>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal direction="up" delay={0.1} className="lg:col-span-7">
            <div
              className="glass-strong glow-border rounded-3xl p-2 overflow-hidden"
              style={{ boxShadow: "0 30px 70px -30px var(--brand-glow)" }}
            >
              <iframe
                title="DIBRAL location"
                src="https://www.google.com/maps?q=India&output=embed"
                className="w-full h-[360px] sm:h-[480px] rounded-[1.4rem] grayscale-[40%] contrast-110 opacity-95"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="contact-map"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

function ContactRow({ icon: Icon, label, value, href, testId }) {
  const Wrapper = href ? "a" : "div";
  return (
    <Wrapper
      {...(href ? { href, target: href.startsWith("http") ? "_blank" : undefined, rel: "noopener noreferrer" } : {})}
      data-testid={testId}
      className="group flex items-center gap-4 glass glow-border rounded-2xl p-4 hover:border-[var(--card-hover-border)] transition tilt-card"
    >
      <span className="icon-3d h-10 w-10">
        <Icon className="w-4 h-4 relative z-10" />
      </span>
      <div>
        <div className="text-[10px] font-mono uppercase tracking-widest text-[var(--body-fg)]/45">{label}</div>
        <div className="text-[var(--body-fg)] text-sm mt-0.5">{value}</div>
      </div>
    </Wrapper>
  );
}
